<template>
    <div id="Error">
        <div class="container">
            <div class="py-5 text-center">
                <h2>There has been an error</h2>
            </div>
            <pre class="code bg-light p-4 mt-5" v-text="this.$route.params" />
        </div>
    </div>
</template>

<script>

export default {
    name: "Error",
    data() {
        return {
           
        };
    },
    watch: {

    },
};
</script>